import React from "react";
import "./WitEarnHome.scss"
import TagContent from "../../components/TagContent/TagContent";
import GridCard from "../../components/GridCard/GridCard";
import OptionList from "../../components/OptionList/OptionList";
import { sortByOrderAscending } from "../../helper/helper";

const WitEarnHomeSolutions = ({ components }) => {

    const getComponents = (key, component) => {
        switch (component.ID) {
            case "TagComponent":
                return <div className="WitEarnHomeSolutions-tg-cont">
                    <TagContent text={component?.Props?.text} isList={component?.Props?.isList} />
                </div>
            case "HeaderText":
                return <div className="WitEarnHomeSolutions-header">
                    {component?.Props?.text}
                </div>
            case "HeaderSubText":
                return <div className="WitEarnHomeSolutions-subheader">
                    {component?.Props?.text}
                </div>
            case "WitEarnHomeSolutionsGrid":
                return <div className="WitEarnHomeSolutions-grid">
                    {component?.Data?.map((feature, index) => {
                        return <GridCard header={feature?.header} key={index} subheader={feature?.subheader} isLearnMore={feature?.isLearnMore} gridIcon={feature?.gridIcon} cardColor={feature.cardColor} />
                    })}
                </div>
            case "WitEarnHomeSolutionsListImge":
                return <div className="WitEarnHomeSolutions-listview">
                    <img alt="" src={component?.Props?.src} className="WitEarnHomeSolutions-listview-img" />
                    <div className="WitEarnHomeSolutions-listview-list">
                        {component?.Data?.map((feature, index) => {
                            return <OptionList header={feature.header} key={index} subheader={feature.subheader} icon={feature?.icon} listColor={feature?.listColor} />
                        })}
                    </div>
                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="WitEarnHomeSolutions">
            {sortByOrderAscending(components).map((component, key) => {
                return getComponents(key, component)

            })}
        </div>
    )
}
export default WitEarnHomeSolutions